export default __webpack_public_path__ + "static/bg_image_blue-e2815627c9e0146a6c7907522b7277a2.jpg";